<ng-container *ngIf="userLoggedIn$ | async">
  <app-navbar [pageUrl]="path"></app-navbar>
</ng-container>
<router-outlet (activate)="onActivate(outlet)" #outlet="outlet"></router-outlet>
<app-error-snack-bar></app-error-snack-bar>
